import { render, staticRenderFns } from "./EditDownloadPage.vue?vue&type=template&id=4b6381f7&"
import script from "./EditDownloadPage.vue?vue&type=script&lang=js&"
export * from "./EditDownloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports